import { render, staticRenderFns } from "./EventListDefaultLayout.vue?vue&type=template&id=be8b4eea"
import script from "./EventListDefaultLayout.vue?vue&type=script&lang=js"
export * from "./EventListDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports